import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReimbursementService } from '../reimbursement.service';
import { EntireUserDetails } from '../reimbursement.interfaces';
import { Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-reimbursement-list',
  templateUrl: './reimbursement-list.component.html',
  styleUrls: ['./reimbursement-list.component.css']
})
export class ReimbursementListComponent implements OnInit {
  user;
  currentPageNo = 1;
  entireUserDetails: EntireUserDetails;
  total;
  perpage;
  noData = false;
  id;
  users;
  i;
  @ViewChild('closeModal') close: ElementRef;
  constructor(private reimbur: ReimbursementService,
    public router: Router,
    private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService,
  ) {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit() {
    this.getEntireUserDetails();
  }
  getEntireUserDetails(pgNo?) {
    if (pgNo != null) {
      this.currentPageNo = pgNo;
    }
    this.spinnerService.show();
    this.reimbur.getEntireUserDetails(this.currentPageNo).subscribe(data => {
      this.spinnerService.hide();
      this.total = data.totalcount;
      this.perpage = data.perpage;
      this.entireUserDetails = data['reimbursement'];
      if (data['reimbursement'].length === 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
    }, error => {
      this.spinnerService.hide();
    })
  }

  viewItemsDetail(id) {
    this.router.navigate(['/reimbursement/view', id]);
  }

  editUserData(id) {
    this.router.navigate(['/reimbursement/edit', id]);
  }
  trackByFn(index) {
    return index;
  }
  deleteUserData(id, user, i) {
    this.id = id;
    this.users = user;
    this.i = i;
  }
  confirmDelete() {
    this.reimbur.deleteUser(this.id).subscribe(data => {
      this.users.splice(this.i, 1);
      this.close.nativeElement.click();
      this.flashService.show(data['message'], 'alert-success');
    });
  }
}



// WEBPACK FOOTER //
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/reimbursement/reimbursement-list/reimbursement-list.component.ts